import { render, staticRenderFns } from "./ProductContentClasses.vue?vue&type=template&id=55f55775&scoped=true&"
import script from "./ProductContentClasses.vue?vue&type=script&lang=js&"
export * from "./ProductContentClasses.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentClasses.vue?vue&type=style&index=0&id=55f55775&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f55775",
  null
  
)

export default component.exports